import imageUrlBuilder from '@sanity/image-url';
import sanityClient, { hasSanityConfig } from '../sanityClient';

const DEFAULT_WIDTH = 1000;
const DEFAULT_QUALITY = 100;

const builder = hasSanityConfig && sanityClient
    ? imageUrlBuilder(sanityClient)
    : null;

const appendParamsToUrl = (url, params) => {
    if (!url) return '';

    const hasQuery = url.includes('?');
    if (!hasQuery) {
        const query = params.toString();
        return query ? `${url}?${query}` : url;
    }

    const [baseUrl, existingQuery] = url.split('?');
    const mergedParams = new URLSearchParams(existingQuery);

    params.forEach((value, key) => {
        mergedParams.set(key, value);
    });

    return `${baseUrl}?${mergedParams.toString()}`;
};

const getAssetUrl = (image) => {
    if (!image || typeof image !== 'object') return '';
    const url = image?.asset?.url || image?.url || '';
    if (!url) return '';
    return url.startsWith('http') ? url : `https:${url}`;
};

const imageLoaderSanity = (image, options = {}) => {
    // If image is already a URL string, apply width and quality parameters
    if (typeof image === 'string') {
        const params = new URLSearchParams();
        params.set('w', String(DEFAULT_WIDTH));
        params.set('q', String(DEFAULT_QUALITY));
        params.set('auto', 'format');
        return appendParamsToUrl(image, params);
    }

    // If image is undefined or null, return empty string
    if (!image) {
        return '';
    }

    // Process Sanity image object
    if (builder) {
        let imageBuilder = builder.image(image);

        if (DEFAULT_WIDTH) imageBuilder = imageBuilder.width(DEFAULT_WIDTH);
        if (DEFAULT_QUALITY) imageBuilder = imageBuilder.quality(DEFAULT_QUALITY);

        return imageBuilder.auto('format').url();
    }

    // Fallback for URL without builder
    const assetUrl = getAssetUrl(image);
    if (!assetUrl) return '';

    const params = new URLSearchParams();
    params.set('w', String(DEFAULT_WIDTH));
    params.set('q', String(DEFAULT_QUALITY));
    params.set('auto', 'format');

    return appendParamsToUrl(assetUrl, params);
};

export default imageLoaderSanity;
